export const dataConsultation=[
    {
        id:"0",
        title:"CONSULTATION DE NATUROPATHIE",
        img_main:"naturo-main.jpg",
        img_illustration:["naturo-main.jpg","naturo_slider.jpg","naturo-ill1.jpg","naturo-ill2.jpg","naturo-ill3.jpg"],
        large_description:`
        <p><u><b>LA CONSULTATION DE NATUROPATHIE</b></u>
        <br />
        <br />
        ‍La consultation naturopathique est une parfaite occasion pour <b>faire le point sur vous-même.</b> Elle commence par un questionnaire qui est une étude approfondie de votre hygiène de vie: habitudes alimentaires, activité physique, sommeil, gestion émotionnelle etc... Une ou plusieurs techniques sont effectuées pour indiquer les éventuelles carences et surcharges : <b>iridologie, réflexologie, bilan oriental et morphotypologie.</b><br />
        Ensemble, nous construisons votre programme qui regroupe des conseils personnalisés pour répondre au mieux à vos attentes.`,
        tarif:`<p>LA CONSULTATION DE NATUROPATHIE
        <br />Tarif : <b>60€ (1h30)</b></p>`
    },
    {
        id:"1",
        title:"CONSULTATION DE FLEURS DE BACH",
        img_main:"fdb-main.jpg",
        img_illustration:["fdb-main.jpg","fdb_slider.jpg","fdb-ill1.jpg","fdb-ill2.jpg","fdb-ill3.jpg"],
        large_description:`

        <p>Élaborés par un célèbre médecin homéopathe en 1930 du nom d'Edward Bach, les élixirs floraux appelés plus communément Fleurs de Bach, sont des remèdes 100% naturels qui permettent de retrouver une paix intérieure. Ce sont 38 extraits de plantes et d’arbres poussant à l’état sauvage préparés selon un procédé spécifique. Les fleurs permettent de <b>rétablir un équilibre émotionnel sans effets secondaires.</b> Peur, colère, manque de confiance en soi, déprime etc... Toutes ces émotions sont alors remises à leur place <b>de manière douce et profonde.</b> Je vous aide à clarifier vos émotions puis, <b>ensemble</b>, nous sélectionnons les fleurs adéquates  et nous préparons votre mélange ce qui vous implique pleinement dans le processus d'évolution.  
        ‍‍‍<br />
        <br />
        
        <b>‍Pourquoi consulter ? </b>
        ‍<br />
        Pour solutionner des situations de stress et de crises :
        <br />
        <ul>
        <li>- Conflits relationnels</li>
        <li>- Difficultés scolaires</li>
        <li>- Perte d’emploi</li>
        <li>- Séparation</li>
        <li>- Deuil</li>
        </ul>
        Pour aider à passer une étape importante, un changement :
        <br />
        <ul>
        <li>- Grossesse</li>
        <li>- Examens</li>
        <li>- Déménagement</li>
        <li>- Puberté</li>
        </ul>
        <b>A qui s’adressent les Fleurs de Bach ?</b>
        <br />
        ‍Tout le monde peut profiter des bienfaits des Fleurs de Bach : les enfants, les adultes, les femmes enceintes.
        ‍<br />
        <br />
        <b>La composition de votre flacon est unique et correspond à votre état émotionnel du moment.</b> Vous repartez de la consultation avec celui-ci, la liste de la composition florale et les bienfaits attendus. Le flacon convient pour une période de 3 semaines.
        ‍
        
        </p>`,
        tarif:`<p>Tarif : <b>45€ (1H)<br />30€</b> pour les enfants</p>`
    }
]